import type { AdminDocumentaryResourceVM } from "@shared-kernel/domain/types/documentary-resource";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const documentaryResourceCatalogRetrieve = createApiThunk<AdminDocumentaryResourceVM[], void>(
  "documentaryResourceCatalog/retrieve",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.getDocumentaryResourcesCatalog();
  },
);
